"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _utils = require("@alycecom/utils");

var _gift = require("../../store/gift/gift.selector");

var _message = require("../../store/gift/postcard/message");

var _customData = require("../../store/customData/customData.selector");

var _invitationType = require("../../store/gift/invitationType");

var _customData2 = require("../../store/customData/customData.actions");

var _GiftMessageSubject = _interopRequireDefault(require("./GiftMessageSubject"));

var _GiftMessageSendAsSelect = _interopRequireDefault(require("./GiftMessageSendAsSelect"));

var _GiftMessageFormValidation = require("./GiftMessageFormValidation");

var _utils2 = require("./utils");

// TODO: rewrite form with react-hook-form
var GiftMessageForm = function GiftMessageForm(_ref) {
  var setHasErrors = _ref.setHasErrors;
  var dispatch = (0, _reactRedux.useDispatch)();
  var sender = (0, _reactRedux.useSelector)(_gift.getGiftSender);
  var isLinkInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedLinkInvitationType);
  var text = (0, _reactRedux.useSelector)(_message.getMessageText);
  var subject = (0, _reactRedux.useSelector)(_message.getMessageSubject);
  var shadowText = (0, _reactRedux.useSelector)(_message.getMessageShadowText);
  var shadowSubject = (0, _reactRedux.useSelector)(_message.getMessageShadowSubject);
  var textCharsLimit = (0, _reactRedux.useSelector)(_invitationType.getMessageTextLimit);
  var isAllowEditTemplate = (0, _reactRedux.useSelector)(_gift.getIsAllowEditTemplate);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var placeholders = (0, _reactRedux.useSelector)(_customData.getCustomDataPlaceholders);
  var isDirectMailInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedDirectMailInvitationType);
  var isMessageSubjectAvailable = !isLinkInvitationType && !isDirectMailInvitationType;
  var textError = (0, _react.useMemo)(function () {
    return (0, _GiftMessageFormValidation.validateField)(text, 'message', 10, textCharsLimit);
  }, [text, textCharsLimit]);
  var subjectError = (0, _react.useMemo)(function () {
    return (0, _GiftMessageFormValidation.validateField)(subject, 'subject', 2, 255);
  }, [subject]) && !isLinkInvitationType;
  (0, _react.useEffect)(function () {
    return setHasErrors(isDirectMailInvitationType ? !!textError : !!subjectError || !!textError);
  }, [setHasErrors, textError, subjectError, isDirectMailInvitationType]);
  (0, _react.useEffect)(function () {
    dispatch((0, _customData2.fetchCustomData)(giftId));
  }, [dispatch, giftId]);
  var replaceWithCustomData = (0, _react.useMemo)(function () {
    var result = {};
    placeholders.forEach(function (placeholder) {
      result["\\[".concat(placeholder.name.slice(1, -1), "\\]")] = placeholder.value;
    });
    return result;
  }, [placeholders]);
  var changedPlaceholders = (0, _react.useMemo)(function () {
    return placeholders.map(function (placeholder) {
      return {
        placeholder: placeholder.name.slice(1, -1),
        label: placeholder.label,
        name: placeholder.name
      };
    });
  }, [placeholders]); // initialize template with placeholders

  (0, _react.useEffect)(function () {
    if (!shadowText) {
      dispatch((0, _message.setShadowText)(text));
    }
  }, [dispatch, text, shadowText]);
  (0, _react.useEffect)(function () {
    if (!shadowSubject) {
      dispatch((0, _message.setShadowSubject)(subject));
    }
  }, [dispatch, subject, shadowSubject]); // apply placeholder replacements

  (0, _react.useEffect)(function () {
    dispatch((0, _message.setText)((0, _utils.mapReplace)(shadowText, replaceWithCustomData)));
  }, [dispatch, shadowText, replaceWithCustomData]);
  (0, _react.useEffect)(function () {
    dispatch((0, _message.setSubject)((0, _utils.mapReplace)(shadowSubject, replaceWithCustomData)));
  }, [dispatch, shadowSubject, replaceWithCustomData]);
  var onTextChange = (0, _react.useCallback)(function (value) {
    var updatedShadowText = (0, _utils2.updateShadowText)(sender, value, shadowText);
    dispatch((0, _message.setText)(value));
    dispatch((0, _message.setShadowText)(updatedShadowText));
  }, [dispatch, shadowText, sender]);
  var onTextTagInsert = (0, _react.useCallback)(function (textWithInsertedTag) {
    dispatch((0, _message.setShadowText)(textWithInsertedTag));
  }, [dispatch]);
  var onSubjectChange = (0, _react.useCallback)(function (_ref2) {
    var currentTarget = _ref2.currentTarget;
    var updatedShadowText = (0, _utils2.updateShadowText)(sender, currentTarget.value, shadowSubject);
    dispatch((0, _message.setSubject)(currentTarget.value));
    dispatch((0, _message.setShadowSubject)(updatedShadowText));
  }, [dispatch, shadowSubject, sender]);
  var handleChangeSendAs = (0, _react.useCallback)(function () {
    dispatch((0, _customData2.fetchCustomData)(giftId));
  }, [dispatch, giftId]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isDirectMailInvitationType && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_GiftMessageSendAsSelect.default, {
    onChange: handleChangeSendAs
  }), /*#__PURE__*/_react.default.createElement(_ui.AlyceDivider, {
    my: 2
  })), isMessageSubjectAvailable && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_GiftMessageSubject.default, {
    disabled: !isAllowEditTemplate,
    error: subjectError,
    subject: subject,
    onChange: onSubjectChange
  })), /*#__PURE__*/_react.default.createElement(_ui.TemplateMessageEditor, {
    disabled: !isAllowEditTemplate,
    value: text,
    hide: isDirectMailInvitationType,
    shadowText: shadowText,
    onChange: onTextChange,
    onInsert: onTextTagInsert,
    error: textError || '',
    tags: changedPlaceholders,
    charsLimit: textCharsLimit
  }));
};

GiftMessageForm.propTypes = {
  setHasErrors: _propTypes.default.func.isRequired
};

var _default = /*#__PURE__*/(0, _react.memo)(GiftMessageForm);

exports.default = _default;